import { ModalProps } from "antd/lib/modal/Modal";
import { Input, message, Modal, Spin, Radio, Select } from "antd";
import React, { useEffect, useRef } from "react";
import Form, { useForm } from "rc-field-form";
import useRequestFn from "../../../../Utils/useRequestFn";
import { ResultMessage } from "../../../../components/ResultMessage";
import useRequest, { errorMessage } from "../../../../Utils/useRequest";
import {
    answerQuestion,
    getAnsweringQuestionDetail,
    getCourseOptions,
    QuestionFormParams,
    QuestionParams
} from "../../../../API/discuss";
import Editor from "../../../../components/Editor";
import FieldWithErrorHaveLabel from "../../../../components/FieldWithErrorHaveLabel";
import useDeviceType from "../../../../Utils/useDeviceType";
import BraftEditor from "braft-editor";
import useBatchPicker from "../../../main/utils/useBatchPicker";
import { isEmpty } from "lodash-es";

type Props = ModalProps &
    QuestionParams & {
        fileName?: string;
        viewUrl?: string;
        onSuccess: () => void;
    };

const Index = ({
    batchNo,
    courseNo,
    courseName,
    courseSeq,
    uuid,
    fileName,
    customerCode,
    viewUrl,
    onSuccess,
    ...props
}: Props) => {
    const [form] = useForm<QuestionFormParams>();
    const editorRef = useRef<BraftEditor>(null);

    const [saveAction, { loading: saveLoading }] = useRequestFn(answerQuestion);

    async function onFinish(data: QuestionFormParams) {
        try {
            const [_courseName, _courseNo, _courseSeq] =
                data?.courseKey?.split("-") || [];
            console.log(_courseName, _courseNo, _courseSeq);
            await saveAction({
                ...data,
                batchNo,
                courseName: _courseName,
                courseNo: _courseNo,
                courseSeq: _courseSeq,
                customerCode,
                uuid
            });
            onSuccess();
            message.success("发表成功，请到答疑栏目中查看你提出的问题", 2);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const [getDataAction, { loading: getLoading }] = useRequestFn(
        getAnsweringQuestionDetail
    );
    async function init() {
        const data = await getDataAction({
            batchNo,
            courseName,
            courseNo,
            courseSeq,
            customerCode,
            uuid
        });
        const {
            questionContent,
            questionTitle,
            allowStudentAnswer,
            anonymousAsk
        } = data;
        editorRef?.current?.setValue(
            BraftEditor.createEditorState(questionContent)
        );
        form.setFieldsValue({
            courseKey: `${data.courseName}-${data.courseNo}-${data.courseSeq}`,
            questionTitle,
            allowStudentAnswer,
            anonymousAsk
        });
    }
    useEffect(() => {
        if (uuid) {
            init();
        } else {
            if (viewUrl) {
                form.setFieldValue(
                    "questionContent",
                    `<a href="${viewUrl}?attname=${fileName}">${fileName}</a>`
                );
            }
            if (courseName) {
                form.setFieldValue(
                    "courseKey",
                    `${courseName}-${courseNo}-${courseSeq}`
                );
            }
        }
    }, []);

    const { isMobile } = useDeviceType();

    const { batch } = useBatchPicker();
    const [options, { loading: optionsLoading }] = useRequest(
        () => getCourseOptions(batch),
        {},
        [batch]
    );

    return (
        <Modal
            {...props}
            okButtonProps={{ loading: [saveLoading, getLoading].some(i => i) }}
            width={800}
            centered={isMobile}
            title="提问"
            onOk={form.submit}>
            <Spin spinning={[saveLoading, getLoading].some(i => i)}>
                <Form form={form} onFinish={onFinish}>
                    <FieldWithErrorHaveLabel
                        rules={[{ required: true, message: "请选择所属课程" }]}
                        require
                        label="所属课程"
                        name="courseKey">
                        <Select
                            disabled={!isEmpty(courseNo)}
                            placeholder="请选择所属课程"
                            style={{ width: "100%", marginBottom: 10 }}>
                            {options?.map(item => (
                                <Select.Option key={item.key} value={item.key}>
                                    {item.key}
                                </Select.Option>
                            ))}
                        </Select>
                    </FieldWithErrorHaveLabel>
                    <FieldWithErrorHaveLabel
                        rules={[{ required: true, message: "请填写标题" }]}
                        require
                        label="标题"
                        name="questionTitle">
                        <Input />
                    </FieldWithErrorHaveLabel>
                    <FieldWithErrorHaveLabel
                        require
                        label="内容"
                        name="questionContent"
                        valuePropName="data">
                        <Editor data="" ref={editorRef} />
                    </FieldWithErrorHaveLabel>
                    <FieldWithErrorHaveLabel
                        label="其他同学回答"
                        align="middle"
                        initialValue="0"
                        help="是否允许其他同学回答该提问"
                        name="allowStudentAnswer">
                        <Radio.Group>
                            <Radio value="0">禁止</Radio>
                            <Radio value="1">允许</Radio>
                        </Radio.Group>
                    </FieldWithErrorHaveLabel>
                    <FieldWithErrorHaveLabel
                        label="匿名提问"
                        align="middle"
                        initialValue="1"
                        help="仅针对学生匿名，但老师仍可看到提问者的个人信息"
                        name="anonymousAsk">
                        <Radio.Group>
                            <Radio value="0">不匿名</Radio>
                            <Radio value="1">匿名</Radio>
                        </Radio.Group>
                    </FieldWithErrorHaveLabel>
                </Form>
            </Spin>
        </Modal>
    );
};
export default Index;
